export default __webpack_public_path__ + "static/media/ic_yellow_arrow_badge.1a2c3f72.svg";